<script>
    import TechnologyCard from './technologyCard.svelte';
    const {title, goto} = rpcjs.props;
    title.set('Technology');
    import {onMount} from 'svelte';

    const textBoxData = [
        {
            Delay: '0.1s',
            heading: 'COMPLEXITY',
            body: 'Simple Spoken Literary',
            span: '',
            img: '/images/technologyPage/1stImage.png',
        },
        {
            Delay: '0.2s',
            heading: 'ACCURACY',
            body: '85 %',
            span: '',
            img: '/images/technologyPage/2ndImage.png',
        },
        {
            Delay: '0.3s',
            heading: 'CHARACTER <br> LIMIT',
            body: 'Unlimited',
            span: 'with logarithmic complexity.',
            img: '/images/technologyPage/3rdImage.png',
        },
        {
            Delay: '0.4s',
            heading: 'SCRIPT <br> COMPLEXITY',
            body: 'Multi Passage',
            span: 'with ulimited scene transitions.',
            img: '/images/technologyPage/4thImage.png',
        },
        {
            Delay: '0.5s',
            heading: 'NPC <br> IDENTITY',
            body: 'Across SCRIPT',
            span: '',
            img: '/images/technologyPage/5thImage.png',
        },
        {
            Delay: '0.6s',
            heading: 'NPC <br> COUNT',
            body: 'UNLIMITED',
            span: '',
            img: '/images/technologyPage/6thImage.png',
        },
    ];
    let laptop;
    let titletext;
    let box;
    let technology;
    let textAi;
    let textAiMove;
    let card;
    let bottom;
    /**
     */
    function loadData() {
        laptop.style.top = '0vh';
        laptop.style.transition = '1.2s';
        bottom = '0vw';
        titletext.style.right = '0.2vw';
        titletext.style.transition = '1.2s';
    }
    /**
     */
    function afterclick() {
        laptop.style.left = '-100vw';
        box.style.bottom = '-100vh';
        box.style.transition = '1s';
        technology.style.left = '-25vw';
        textAi.style.opacity = '100%';
        textAiMove.style.right = '-100vw';
        textAiMove.style.transition = '1s';
        card.style.right = '0vw';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(loadData, 10);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            afterclick();
        }
        if (e.key == 'ArrowLeft') {
            goto('/future');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>
<section on:click={afterclick} role="presentation">
    <div class="backimgLaptop" bind:this={laptop}>
        <img
            src="/images/technologyPage/laptopbackgrond.png"
            alt="Laptop"
            width="100%"
            height="100%"
        />
        <div class="videoSeciton">
            <video
                src="https://static.opus.ai/demo.mp4"
                type="mp4"
                loop
                muted
                autoplay
            />
        </div>
    </div>
    <div class="bottomTextBoxes" bind:this={box}>
        {#each textBoxData as data}
            <div class="textBox" style="bottom:{bottom};transition-Delay:{data.Delay};" >
                <div class="texthead"><p>{@html data.heading}</p></div>
                <div class="imgWrraper">
                    <img
                        src={data.img}
                        alt="backgroundImage"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="textDescription">
                    <p>{data.body}</p>
                    <p>{data.span}</p>
                </div>
            </div>
        {/each}
    </div>
    <div class="pageMainTitle" bind:this={titletext}>
        <div class="mainTitle">
            <h1 bind:this={technology}>Technology Readiness</h1>
            <h2 bind:this={textAiMove}>NATURAL LANGUAGE</h2>
            <h2 bind:this={textAi}>GENERATIVE AI</h2>
        </div>
    </div>
    <div class="card" bind:this={card}>
        <TechnologyCard />
    </div>
</section>

<style>
    /* .bottomTextBoxes .textBox:nth-child(1){
       top: 0vw;
       transition: 1s;
       transition-delay: 1s;
    }
    .bottomTextBoxes .textBox:nth-child(2){
       top: 0vw;
       transition: 1s;
       transition-delay: 5s;
    }
    .bottomTextBoxes .textBox:nth-child(3){
       top: 0vw;
       transition: 1s;
       transition-delay: 3s;
    }
    .bottomTextBoxes .textBox:nth-child(4){
       top: 0vw;
       transition: 1s;
       transition-delay: 4s;
    } */
    section {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        font-style: normal;
        position: relative;
        font-family: "Montserrat";
        background-color: #010422;
    }
    .backimgLaptop {
        position: relative;
        height: 100vh;
        margin: auto;
        width: auto;
        top: -50vh;
        left: 0vw;
        transition-duration: 0.5s;
    }
    .videoSeciton {
        background-color: black;
        position: absolute;
        overflow: hidden;
        height: 74vh;
        left: 13vw;
        width: 74%;
        top: 0;
    }
    .videoSeciton video {
        height: auto;
        width: 100%;
    }
    .bottomTextBoxes {
        box-sizing: border-box;
        position: absolute;
        overflow: hidden;
        height: 29.167vh;
        width: 100%;
        bottom: 0vh;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        transition-duration: 0.5s;
    }
    .textBox {
        border-radius: 2.083vw 2.083vw 0 0;
        background-color: #ff007f;
        box-sizing: border-box;
        position: relative;
        height: 29.167vh;
        width: 15.104vw;
        bottom: -30vh;
        transition: 1s;
    }
    .textBox:nth-child(2) .textDescription P {
        font-size: 3.125vw;
        text-align: center;
    }
    .texthead {
        border-radius: 2.083vw 2.083vw 0 0;
        background-color: white;
        justify-content: center;
        align-items: center;
        position: relative;
        text-align: center;
        height: 7.593vh;
        width: inherit;
        display: flex;
        z-index: 1;
    }
    .texthead p {
        text-transform: uppercase;
        box-sizing: border-box;
        line-height: 2.5vh;
        text-align: center;
        /* font-size: 1.563vw; */
        font-size: min(1.563vw , 2.778vh);
        color: #020522;
        font-weight: 800;
        margin: 0;
    }
    .textBox:nth-child(1) .textDescription {
        position: absolute;
        bottom: 4vh;
        width: 100%;
    }
    .textBox:nth-child(2) .textDescription {
        position: absolute;
        bottom: 6vh;
        width: 100%;
    }
    .textBox:nth-child(3) .textDescription {
        position: absolute;
        bottom: 6vh;
        width: 100%;
    }
    .textBox:nth-child(4) .textDescription {
        position: absolute;
        bottom: 5vh;
        width: 100%;
    }
    .textBox:nth-child(5) .textDescription {
        position: absolute;
        bottom: 6.5vh;
        width: 100%;
    }
    .textBox:nth-child(6) .textDescription {
        position: absolute;
        bottom: 8vh;
        width: 100%;
    }
    .textDescription p {
        margin: 0;
        color: white;
        font-weight: 900;
        line-height: 100%;
        text-align: center;
        /* font-size: 2.083vw; */
        font-size: min(2.083vw ,3.704vh);
        text-transform: uppercase;
    }
    .textDescription p:nth-child(2) {
        font-weight: 500;
        text-align: left;
        /* font-size: 1.042vw; */
        font-size: min(1.042vw, 1.852vh);
        margin-left: 2.1vw;
    }
    .textBox:nth-child(4) .textDescription p:nth-child(1) {
        text-transform: uppercase;
        /* font-size: 2.083vw; */
        font-size: min(2.083vw ,3.704vh);
        margin-left: 1.5vw;
        line-height: 100%;
        font-weight: 900;
        text-align: left;
        color: white;
    }
    .textBox:nth-child(1) .imgWrraper {
        margin: -2vh auto;
        height: 21.944vh;
        width: 18.426vh;
        opacity: 0.5;
    }
    .textBox:nth-child(2) .imgWrraper {
        margin: 2vh auto;
        height: 20.185vh;
        width: 20.185vh;
        opacity: 0.5;
    }
    .textBox:nth-child(3) .imgWrraper {
        margin: 2vh auto;
        height: 17.963vh;
        width: 15.648vh;
        opacity: 0.5;
    }
    .textBox:nth-child(4) .imgWrraper {
        margin: 2.5vh auto;
        height: 17.361vh;
        width: 18.519vh;
        opacity: 0.5;
    }
    .textBox:nth-child(5) .imgWrraper {
        margin: 3vh auto;
        height: 16.204vh;
        width: 16.204vh;
        opacity: 0.5;
    }
    .textBox:nth-child(6) .imgWrraper {
        margin: 7vh auto;
        height: 8.796vh;
        width: 22.13vh;
        opacity: 0.5;
    }
    .pageMainTitle {
        position: absolute;
        top: 10vh;
        right: -50vw;
        transition-duration: 0.5s;
    }
    .pageMainTitle .mainTitle h1 {
        margin: 0;
        color: #ff007f;
        /* width: 104.074vh; */
        width: 55vw;
        font-weight: 900;
        text-align: right;
        line-height: 75.4%;
        /* font-size: 13.889vh; */
        /* font-size: 7.813vw; */
        font-size: min(7.813vw  , 13.889vh);
        letter-spacing: -0.045em;
        text-transform: uppercase;
        text-shadow: 0vh 0.37vh 0.37vh rgb(0 0 0 / 25%);
        position: relative;
        left: 0vw;
        transition-duration: 0.5s;
    }
    .pageMainTitle .mainTitle h2 {
        text-transform: uppercase;
        transition-duration: 0.5s;
        letter-spacing: 0.2em;
        /* font-size: 3.704vh; */
        /* font-size: 2.083vw; */
        font-size: min(2.083vw , 3.0704vh);
        line-height: 84.4%;
        position: relative;
        color: #ffffff;
        text-align: end;
        font-weight: 700;
        right: 0vw;
        margin: 0;
    }
    .pageMainTitle .mainTitle h2:nth-child(3) {
        text-transform: uppercase;
        transition-duration: 0.8s;
        letter-spacing: 0.2em;
        position: relative;
        /* font-size: 3.704vh; */
        /* font-size: 2.083vw; */
        font-size: min(2.083vw ,3.704vh);
        line-height: 84.4%;
        color: #ffffff;
        font-weight: 700;
        text-align: end;
        left: -25vw;
        opacity: 0%;
        margin: 0;
        top: -3vh;
    }
    .card {
        top: 0vh;
        z-index: 1;
        width: 100%;
        height: 100%;
        right: -100vw;
        position: absolute;
        transition-duration: 0.5s;
    }
</style>
